import { UnlockVideoResponse } from '../interfaces'
import { GETWithAuth } from './Index'

export async function UnlockVideo(mint: string): Promise<UnlockVideoResponse> {
  return await GETWithAuth<UnlockVideoResponse>(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/gated/${mint}`
  )
}
